import { AxiosResponse } from 'axios'
import apiClient from './common/common'
import { PositionNumberType } from './common/constants'

export const getSummaryDocument = async (callback: (response: Blob) => void) => {
  await apiClient.get('/document/summary', { responseType: 'blob' }).then((response: AxiosResponse<Blob>) => {
    if (response.status === 200) {
      callback(response.data)
    }
  })
}

export const getContractDocumentAll = async (callback: (response: Blob) => void) => {
  await apiClient.get('/document/contract', { responseType: 'blob' }).then((response: AxiosResponse<Blob>) => {
    if (response.status === 200) {
      callback(response.data)
    }
  })
}

export const getContractDocument = async (positionNumber: PositionNumberType, callback: (response: Blob) => void) => {
  await apiClient.get(`/document/contract/${positionNumber}`, { responseType: 'blob' }).then((response: AxiosResponse<Blob>) => {
    if (response.status === 200) {
      callback(response.data)
    }
  })
}
